import { render, staticRenderFns } from "./SolInternas.vue?vue&type=template&id=ff73f92e&scoped=true&"
import script from "./SolInternas.vue?vue&type=script&lang=js&"
export * from "./SolInternas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff73f92e",
  null
  
)

export default component.exports